import Button from '@/atoms/Button/Button'
import {
  CustomFormSource,
  triggerServiceOrderingFlow
} from '@/utils/functions/order'

/* assets */
import { ReactComponent as LetterIcon } from 'public/assets/icons/letter.svg'

interface Props {
  formSource: CustomFormSource
}

function NewsLetterSubscriptionCard({ formSource }: Props): JSX.Element {
  return (
    <section className="bg-green-20  | text-center  |  rounded-lg  |  p-5 md:py-12 md:px-10">
      <div className="bg-green-70  |  flex items-center justify-center  |  rounded-full  |  w-14 h-14  | mx-auto mb-6">
        <LetterIcon />
      </div>

      <h2 className="text-paragraph-2 text-cyan-90  |  mb-6">
        The latest from Pepper Content, right in your inbox
      </h2>

      <Button
        onClick={() => triggerServiceOrderingFlow({ formType: formSource })}
      >
        Subscribe
      </Button>
    </section>
  )
}

export default NewsLetterSubscriptionCard
